import React from 'react'

import LancamentoVendaFormPageContainer from './LancamentoVendaFormPageContainer'

export class LancamentoVendaFormPage extends React.Component {
  render() {
    return <LancamentoVendaFormPageContainer {...this.props} />
  }
}
